UC.views.DraftProposalTemplateList = UC.components.ProposalTemplateListAbstract.extend({
  template: UC.views.resolveHandlebarsTemplate("components/draft_proposal_template_list")
});
